// extracted by mini-css-extract-plugin
module.exports = {"citationLists":"citation-lists_citationLists__BZzIO","newCitationListIcon":"citation-lists_newCitationListIcon__u7Sbq","newCitationList":"citation-lists_newCitationList__tZjDq"};